import * as React from 'react';

/** Glides to same-page #anchors (e.g. "Compare every feature") instead of
 * jumping. Global CSS scroll-behavior would also animate Gatsby's
 * scroll-to-top on page changes, so only in-page links are handled here.
 * `scroll-margin-top` on [id] (ThemeStyles) keeps targets clear of the nav. */
export const SmoothAnchors: React.FC = () => {
  React.useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (e.defaultPrevented || e.button !== 0) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      const a = (e.target as HTMLElement).closest?.('a');
      if (!a?.hash || a.origin !== window.location.origin) return;
      if (a.pathname !== window.location.pathname) return;
      const target = document.getElementById(
        decodeURIComponent(a.hash.slice(1)),
      );
      if (!target) return;
      e.preventDefault();
      const reduced = window.matchMedia(
        '(prefers-reduced-motion: reduce)',
      ).matches;
      target.scrollIntoView({ behavior: reduced ? 'auto' : 'smooth' });
      window.history.pushState(null, '', a.hash);
    };
    document.addEventListener('click', onClick);
    return () => document.removeEventListener('click', onClick);
  }, []);
  return null;
};
